import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Mail, Instagram, Music2 } from "lucide-react";
import { api } from "@/lib/api";
import { waLink, PAYMENT_METHODS } from "@/lib/constants";

const Footer = () => {
  const [social, setSocial] = useState({ instagram_url: "", tiktok_url: "" });

  useEffect(() => {
    api.get("/settings/public").then((r) => setSocial(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-[#EADFCB] bg-[#1A1714] text-[#F7EEDB]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-8 md:grid-cols-3">
        <div>
          <p className="font-accent text-2xl tracking-[0.3em] text-[#C59B27]">ANM PARIS</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#F7EEDB]/70">
            Maison de parfumerie de luxe. Les plus grandes maisons — Chanel, Dior, Yves Saint Laurent,
            Lancôme, Armani — sélectionnées avec passion pour vous.
          </p>
          {(social.instagram_url || social.tiktok_url) && (
            <div className="mt-5 flex gap-3" data-testid="footer-socials">
              {social.instagram_url && (
                <a
                  href={social.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  aria-label="Instagram"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-[#C59B27]/40 text-[#C59B27] transition-all hover:bg-[#C59B27] hover:text-[#1A1714]"
                >
                  <Instagram size={17} />
                </a>
              )}
              {social.tiktok_url && (
                <a
                  href={social.tiktok_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-tiktok"
                  aria-label="TikTok"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-[#C59B27]/40 text-[#C59B27] transition-all hover:bg-[#C59B27] hover:text-[#1A1714]"
                >
                  <Music2 size={17} />
                </a>
              )}
            </div>
          )}
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">Navigation</p>
          <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {[
              { to: "/", label: "Accueil" },
              { to: "/boutique", label: "Boutique" },
              { to: "/trouver-mon-parfum", label: "Trouver mon parfum" },
              { to: "/comparer", label: "Comparateur" },
              { to: "/favoris", label: "Favoris" },
              { to: "/fidelite", label: "Fidélité" },
              { to: "/suivi", label: "Suivi de commande" },
            ].map((l) => (
              <Link key={l.to} to={l.to} className="text-[#F7EEDB]/70 transition-colors hover:text-[#C59B27]">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">Contact & Paiements</p>
          <div className="mt-4 space-y-2 text-sm">
            <a
              href={waLink("Bonjour ANM Paris, je souhaiterais obtenir des informations sur vos parfums.")}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#F7EEDB]/70 transition-colors hover:text-[#25D366]"
            >
              <MessageCircle size={15} /> +90 542 872 27 48
            </a>
            <a
              href="mailto:Anmparis20@gmail.com"
              className="flex items-center gap-2 text-[#F7EEDB]/70 transition-colors hover:text-[#C59B27]"
            >
              <Mail size={15} /> Anmparis20@gmail.com
            </a>
          </div>
          <p className="mt-4 text-xs leading-relaxed text-[#F7EEDB]/50">
            Paiements acceptés : {PAYMENT_METHODS.map((m) => m.label).join(" • ")}
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#F7EEDB]/50">
        © {new Date().getFullYear()} ANM Paris — Tous droits réservés ·{" "}
        <Link to="/admin" data-testid="admin-dashboard-link" className="transition-colors hover:text-[#C59B27]">
          Espace propriétaire
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
